{
  "id": "one-dark",
  "name": "One Dark",
  "description": "One Dark theme inspired by Atom editor",
  "colors": {
    "light": {
      "primary": "#528bff",
      "secondary": "#e5c07b",
      "positive": "#98c379",
      "negative": "#e06c75",
      "warning": "#e5c07b",
      "important": "#d19a66",
      "light": "#ffffff",
      "dark": "#21252b",
      "surface": "#f8f8f2",
      "darksurface": "#282c34",
      "white": "#FAFAFA"
    },
    "dark": {
      "primary": "#61afef",
      "secondary": "#e5c07b",
      "positive": "#98c379",
      "negative": "#e06c75",
      "warning": "#e5c07b",
      "important": "#d19a66",
      "light": "#ffffff",
      "dark": "#21252b",
      "surface": "#f8f8f2",
      "darksurface": "#282c34",
      "white": "#FAFAFA"
    }
  }
}
